import { render, staticRenderFns } from "./ButtonShareGroup.vue?vue&type=template&id=66256056&lang=pug&"
import script from "./ButtonShareGroup.vue?vue&type=script&lang=js&"
export * from "./ButtonShareGroup.vue?vue&type=script&lang=js&"
import style0 from "./ButtonShareGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports